"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderDetailPage = void 0;
var OrderDetail_1 = require("./OrderDetail");
Object.defineProperty(exports, "OrderDetailPage", { enumerable: true, get: function () { return OrderDetail_1.OrderDetailPage; } });
